<template>
    <div class="card">
      <div class="card-header text-lg cardPause">
        <span class="badge badge-warning mr-2">{{ iniciadas.length }}</span>
        {{ $t('Execuções em Pause') }}
      </div>
  
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-12 text-center pt-3 animated fadeout" v-if="!iniciadas">
            <span style="font-size: 2rem">
              <i class="fas fa-pulse fa-spinner mr-3"></i>Carregando...
            </span>
          </div>
          <div class="col-12 text-center pt-3 animated fadeout" v-if="iniciadas && iniciadas.length == 0">
            <span style="font-size: 2rem">
              {{ $t('Nenhuma execução em pause') }}.
            </span>
          </div>

          <div class="col-12" v-if="iniciadas">
            <div v-for="(tecnico, index) in iniciadas" :key="index">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body bg-light">
                      <execucao-pausada :execucao="tecnico"></execucao-pausada>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <modal-tecnicos></modal-tecnicos>
    </div>
  </template>
  
  <script>
  // import ExecucaoAtiva from '@/components/ExecucaoAtiva'
  import ExecucaoPausada from '@/components/ExecucaoPausada'
  import ModalTecnicos from '@/components/ModalTecnicos'
  
  export default {
    components: {
      // ExecucaoAtiva,
      ExecucaoPausada,
      ModalTecnicos
    },
  
    data() {
      return {
        visible: null,
        nameMecanico: '',
        numExecucao: 0
      }
    },

    created(){
      this.$store.dispatch('osItemExecucao/fetchOsEmPauseFromApi', { nr_tipo: 'O' })
      this.$store.dispatch('osItemExecucao/fetchOsEmPauseFromApi', { nr_tipo: 'V' })
    },

    computed: {
      
      filial() {
        return this.$store.getters['filial/filial']
      },
      frotaItems() {
        const items = this.$store.getters['frotaItem/items']
  
        if (!items && this.filial) {
          this.$store.dispatch('frotaItem/fetchFromApi', {
            params: {
              filial: this.filial.nr_sequencial, estoque: true
            }
          })
          return []
        }
        return items
      },
  
      iniciadas() {
        if(this.$store.getters['osItemExecucao/osEmPause']){
          this.totExecucao(this.$store.getters['osItemExecucao/osEmPause'])
        }
  
        return this.$store.getters['osItemExecucao/osEmPause']
      },
      countExecucao() {
        return this.$store.getters['osItemExecucao/osEmPause']
      },
      // execucaoData() {
      //   return this.$store.getters['osItemExecucao/data']
      // }
    },
  
    methods: {
      mostraParar(tecnico) {
        let mecanicoOs = JSON.parse(localStorage.filial)
        if (mecanicoOs.atendeOs === 'S') {
          if (tecnico == mecanicoOs.dsColaborador) {
  
            return true
          }
  
          return false
        }
  
        return true
      },
      totExecucao(response) {
        let mecanicoOs = JSON.parse(localStorage.filial)
        console.log(mecanicoOs)

        // if (mecanicoOs.atendeOs == 'S') {
        //   for (let i = 0; i <= response.length; i++) {
        //     if (response[i] != undefined) {
        //       if (mecanicoOs.dsColaborador == response[i].ds_colaborador) {
        //         this.numExecucao = response[i].execucoes_iniciadas.length
        //       }
        //     }
        //   }
        // } else {
        //   this.numExecucao = this.countExecucao
        // }
         
      }
    }
  }
  </script>
<style>
.cardPause{
  background: #f5a903;
    border-radius: 25px!important;
}
</style>
  